import useLocaleStore from '~/stores/useLocaleStore';
export default defineComponent({
  name: 'DesktopAppBar',
  props: {
    borderless: {
      type: Boolean
    }
  },
  setup: function setup() {
    var locale = useLocaleStore();
    return {
      locale: locale
    };
  }
});